export default class CommandTask
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.CommandTask";
	cmd;
	group;
	control;
	arg;
	
	setGroup(group)
	{
		this.group = group;
		return this;
	}
	
	setControl(control)
	{
		this.control = control;
		return this;
	}
	
	setArg(arg)
	{
		this.arg = arg;
		return this;
	}
}


// WEBPACK FOOTER //
// ./src/forms/sys/remote/CommandTask.js